import React, { useMemo } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, styled, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InexButton from "../../InexButton";
import CreateComment from "./CreateComment";
import { useGetStepCommentsQuery } from "../../../store/api/odyssee";
import { useAuthToken } from "../../../hooks/auth";
import CommentCard from "./CommentCard";
import { getInreesId } from "../../../store/reducers/authSlice";
import { useSelector } from "react-redux";
import { useIsMobile } from "../../../hooks/responsive";
import CommunityPng from "../../../resources/images/png/COMMU.png";

const Container = styled(Box)(({ hasMargins }) => {
	return {
		marginLeft: hasMargins ? "3vw" : undefined,
		marginRight: hasMargins ? "3vw" : undefined,
		borderRadius: "20px",
		display: "flex",
	};
});

const InexAccordion = styled(Accordion)(() => {
	return {
		backgroundColor: "#FFFFFF0F",
		borderRadius: "20px",
		padding: "5px",
		borderTopLeftRadius: "20px !important",
		borderTopRightRadius: "20px !important",
		borderBottomRightRadius: "20px !important",
		borderBottomLeftRadius: "20px !important",
		width: "100%",
		"..MuiAccordion-root": {},
	};
});
const StepQuestion = ({ stepId }) => {
	const [isExpanded, setExpanded] = React.useState(true);
	const [isModalOpen, setModelOpen] = React.useState(false);
	const authToken = useAuthToken();
	const inreesId = useSelector(getInreesId);

	const { data: userQuestions, refetch: refetchUserQuestions } = useGetStepCommentsQuery(
		{ authToken, leconid: stepId, page: 0 },
		{ skip: !stepId || !authToken },
	);

	const createNewQuestion = (event) => {
		event?.stopPropagation();
		setModelOpen(true);
	};

	const filteredComments = React.useMemo(() => {
		return userQuestions?.questions.filter((comment) => {
			if (comment.state === 2) return true;
			if (comment.state === 0) {
				return comment.idinexplore === parseInt(inreesId, 10);
			}
			return false;
		});
	}, [userQuestions, inreesId]);

	const isMobile = useIsMobile();

	return (
		<Container hasMargins={stepId !== 0}>
			<InexAccordion onChange={(event, expanded) => setExpanded(expanded)} defaultExpanded={true}>
				<AccordionSummary
					aria-controls="panel1-content"
					id="panel1-header"
					sx={{ width: "100%", margin: 0, maxWidth: "1OO%" }}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							width: "100%",
						}}
					>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
							}}
						>

								
							<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}> 
								<img
									alt={"odysee picture"}
									src={CommunityPng}
									style={{
										objectFit: "cover",
										width: 70,
										height: 70,
										borderRadius: "50%",
										overflow: "hidden",
									}}
								/>
								<Typography color={"#ffffff"} fontFamily={"Branding"} fontWeight={"bold"} fontSize={24}>
									Commentaires
								</Typography>
							</Box>
							<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
								{!isMobile && (
									<InexButton
										onClick={createNewQuestion}
										variant={"text"}
										textWithGradient={false}
										textSx={{
											color: "#ffffff",
										}}
										sx={{
											backgroundColor: "#EF7D8F",
											width: 260,
										}}
										text={"Laisser un commentaire"}
									/>
								)}
								<ExpandMoreIcon
									sx={{
										color: "white",
										transform: `rotate(${isExpanded ? 180 : 0}deg)`,
										transition: "transform 0.2s ease",
									}}
								/>
							</Box>
						</Box>
						{isMobile && (
							<InexButton
								onClick={createNewQuestion}
								variant={"text"}
								textWithGradient={false}
								textSx={{
									color: "#ffffff",
								}}
								sx={{
									backgroundColor: "#EF7D8F",
									mt: 1,
									width: "100%",
								}}
								text={"Laisser un commentaire"}
							/>
						)}
					</Box>
				</AccordionSummary>
				<AccordionDetails>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
						{filteredComments?.map((question) => (
							<CommentCard
								key={question?.id}
								firstName={question?.prenom}
								lastName={question?.nom}
								date={question?.creation}
								question={question?.message}
							/>
						))}
					</Box>
				</AccordionDetails>
			</InexAccordion>

			<CreateComment
				handleModalClose={() => setModelOpen(false)}
				isOpen={isModalOpen}
				refetchUserQuestions={refetchUserQuestions}
				stepId={stepId}
			/>
		</Container>
	);
};

export default StepQuestion;
